// Cookie names owned by the delivery module. Private to `storage/`.

export const COOKIE_DELIVERY_AREA_POSTAL_CODE = 'next-app-postalCode'
export const COOKIE_DELIVERY_AREA_CITY = 'next-app-city'
export const COOKIE_SUPPORTED_POSTAL_CODE = 'next-app-supportedPostalCode'
